"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringType = void 0;
/**
 * Used for filtering tracker rotations in software
 */
var FilteringType;
(function (FilteringType) {
    FilteringType[FilteringType["NONE"] = 0] = "NONE";
    FilteringType[FilteringType["SMOOTHING"] = 1] = "SMOOTHING";
    FilteringType[FilteringType["PREDICTION"] = 2] = "PREDICTION";
})(FilteringType = exports.FilteringType || (exports.FilteringType = {}));
